import { get } from 'svelte/store';
import { userid, items, COLS, clientID, isProduction } from './utils';

const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-lz.a.run.app';
const configsLive = 'https://beta-sb-app-configs-djgqciaueq-ew.a.run.app';
export const apiBase = () => {
  return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
};

export async function listGrid() {
  const client = get(clientID);
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;

  const url = apiBase() + `/configs/homepage/list/${client}${userToken}`;
  const res = await fetch(url);
  const json = await res.json();

  return json;
}

export async function getGrid(id) {
  const client = get(clientID);
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;
  const url = apiBase() + `/configs/homepage/customer/${client}${userToken}&grid_id=${id}`;
  const res = await fetch(url);
  const json = await res.json();
  return json;
}
export async function checkGridState(id) {
  const client = get(clientID);
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;
  const url = apiBase() + `/live${userToken}&cid=${client}&grid_id=${id}`;
  const res = await fetch(url);
  const json = await res.json();
  return json.live;
}
export const saveGridConfig = async (id, gridName, css, preview = false) => {
  let cells = get(items);
  let devices = ['mobile', 'desktop'];
  let gridItems = {};
  devices.forEach((device) => {
    gridItems[device] = { items: [] };
    let columns = device == 'mobile' ? 1 : COLS;
    let matrix = [];

    cells[device].forEach((item) => {
      columns = item[columns] ? columns : COLS;
      let y = item[columns].y;
      if (!matrix[y]) matrix[y] = [];

      matrix[y].push(item);
      matrix[y].sort((a, b) => (a[columns].x > b[columns].x ? 1 : -1));
    });

    matrix.flat().forEach((item) => {
      let cell = item.data;
      cell.size = item[columns].w;
      if (device == 'mobile') {
        cell.size = 1;
      }
      if (cell.type == 'banner') {
        cell.collection = 'banner';
      }
      gridItems[device].items = [cell, ...gridItems[device].items];
    });
  });
  // console.log(gridItems);
  console.log({
    id: id,
    name: gridName,
    custom_css: css,
    ...gridItems,
  });
  return await postGrid({
    id: id,
    name: gridName,
    custom_css: css,
    preview: preview,
    ...gridItems,
  });
};
export async function postGrid(config) {
  const client = get(clientID);
  const userToken = `?token=${get(userid)}`;
  const location = config.preview == true ? 'grid-preview' : 'homepage';
  if (userToken == '?token=undefined') return;
  const url = apiBase() + `/configs/${location}/customer/${client}${userToken}`;
  const res = await fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  });
  const json = await res.json;
  return json;
}
export async function deleteGrid(payload) {
  const client = get(clientID);
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;
  const url = apiBase() + `/configs/homepage/customer/${client}${userToken}&grid_id=${payload.id}`;
  const res = await fetch(url, {
    method: 'delete',
  });
  const json = await res.json;
  return json;
}
